import api from '../utils/axiosClient';
import createResource from './createResource';

const url = '/widgets';

const widgetUsersResource = createResource<any>({
  key: 'widgetUser',
  url,
});

function login({ id, hash }: any) {
  return api.post(`${url}/login`, { id, hash });
}

export default {
  ...widgetUsersResource,
  login,
};
